import React from 'react';
import './ContactFab.css';

const WA_NUMBER = '916289428163';
const PHONE     = '+916289428163';
const WA_MSG = encodeURIComponent(
    'Hi FriendsHotel.In আমি কলকাতা থেকে সিকিম ট্যুর প্ল্যান করছি। Please share Pelling / Rinchenpong / Gangtok package details.'
);

function track(action) {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', 'generate_lead', {
        event_category: 'contact_fab',
        event_label: action,
        transport_type: 'beacon',
    });
}

/* Site-wide floating contact buttons — WhatsApp first (primary booking
   channel for the Kolkata audience), phone call as fallback. */
export default function ContactFab() {
    return (
        <div className="cfab" role="complementary" aria-label="Quick contact">
            <a
                className="cfab-btn cfab-call"
                href={`tel:${PHONE}`}
                aria-label="Call Friends Hotel: +91 62894 28163"
                title="Call us: +91 62894 28163"
                onClick={() => track('call_click')}
            >
                <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
                    <path fill="currentColor" d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.61 21 3 13.39 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2Z" />
                </svg>
            </a>
            <a
                className="cfab-btn cfab-wa"
                href={`https://wa.me/${WA_NUMBER}?text=${WA_MSG}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat on WhatsApp with Friends Hotel"
                title="Book on WhatsApp — instant reply"
                onClick={() => track('whatsapp_click')}
            >
                <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
                    <path fill="currentColor" d="M12 2a10 10 0 0 0-8.65 15.02L2 22l5.13-1.32A10 10 0 1 0 12 2Zm0 18.18a8.16 8.16 0 0 1-4.16-1.14l-.3-.18-3.04.78.8-2.96-.2-.31a8.18 8.18 0 1 1 6.9 3.81Zm4.49-6.13c-.25-.12-1.45-.72-1.68-.8-.22-.08-.39-.12-.55.13-.16.24-.63.8-.77.96-.14.16-.29.18-.53.06-.25-.12-1.04-.38-1.97-1.22-.73-.65-1.22-1.46-1.36-1.7-.14-.25-.02-.38.1-.5.12-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.16.04-.31-.02-.43-.06-.12-.55-1.33-.76-1.82-.2-.48-.4-.42-.55-.42h-.47c-.16 0-.43.06-.66.31-.22.24-.86.84-.86 2.05 0 1.2.88 2.37 1 2.53.12.16 1.73 2.64 4.18 3.7.59.25 1.04.4 1.4.52.59.18 1.12.16 1.54.1.47-.07 1.45-.6 1.65-1.17.2-.57.2-1.06.15-1.17-.06-.1-.23-.16-.47-.28Z" />
                </svg>
                <span className="cfab-wa-label">Book on WhatsApp</span>
            </a>
        </div>
    );
}
